<template>
  <b-dropdown
    ref="dropdown"
    @active-change="openRecordList"
  >
  <div :class="{'has-text-weight-bold' : isBold}" slot="trigger" style="cursor: pointer">{{ value }}  {{ value === 1 ? 'Lead' : 'Leads' }}</div>

    <b-dropdown-item custom style="min-width: 370px">
      <div class="has-text-weight-bold has-text-centered px-100">{{ label }}</div>
      <div class="records-container">
        <div v-if="records.length" class="mt-100">
          <stats-kpi-record-item
            v-for="record in records"
            @recordOpen="toggle"
            :record="record"
            :key="record.id"
          ></stats-kpi-record-item>
        </div>

        <div v-if="isLoading" style="min-height: 80px">
          <b-loading class="app-loader" :active="isLoading" :is-full-page="false"></b-loading>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import StatsKpiRecordItem from './StatsKpiRecordItem';

export default {
  components: { StatsKpiRecordItem },
  props: {
    label: String,
    value: Number,
    api: String,
    campaignFilter: Array,
    timeframe: Object,
    isBold: Boolean
  },
  data() {
    return {
      isLoading: true,
      records: []
    }
  },
  methods: {
    openRecordList(isOpen) {
      const start_at = this.timeframe.start_at.toISOString();
      const end_at = this.timeframe.end_at.toISOString();

      if (isOpen && !this.records.length) {
        this.$api.stats.getFunnelStatRecords(this.api, {start_at, end_at, campaigns: this.campaignFilter}).then((res) => {
          this.isLoading = false;
          this.records = res.data;
        });
      }
    },
    toggle() {
      this.$refs.dropdown.toggle();
    }
  }
}
</script>

<style lang="scss" scoped>
.records-container {
  cursor: initial;
  max-height: 400px;
  overflow: auto;
  padding: 0 5px;
  position: relative;
}
</style>
